module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/core-js/modules/_html.js
// module id = 167
// module chunks = 1